/**
 * One-way onboarding latch on a customer row, read by the login router
 * (EDUS-2726) to route a verified super admin to the app or the onboarding
 * wizard.
 *
 * - `uninitialized` — tenant row exists (console- or auto-created) but the
 *   onboarding wizard has not completed; the router resolves WIZARD.
 * - `initialized`   — onboarding completed (flipped at the END of the wizard,
 *   when the user finishes Step 5 "Invite Users", US-8/EDUS-2687) or the row
 *   predates the wizard (migration backfill grandfathers every pre-existing
 *   customer).
 *
 * A string union rather than a boolean to leave room for future states
 * (e.g. suspended/offboarding). The latch never auto-reverts and the router
 * never re-derives it from facts — only an explicit support action may
 * change it.
 */
export const ONBOARDING_STATUSES = ['uninitialized', 'initialized'] as const;

/** Derived from the array above so a new status can't be added to only one. */
export type OnboardingStatus = (typeof ONBOARDING_STATUSES)[number];
